export default {
  warranty: {
    id: 'outlet_reassurance_warranty',
    defaultMessage: '1-year warranty',
  },
  returns: {
    id: 'outlet_reassurance_returns',
    defaultMessage: '30-day returns',
  },
  inspection: {
    id: 'outlet_reassurance_inspection',
    defaultMessage: 'Professional inspection',
  },
}
